const productSearchBar = {
  ePrescription: '(E-)Prescription',
  upload: 'Upload',
  label: 'Search for medication (Product name, PZN...)',
  searchAll: 'Show all results for "{search}".',
  barcodeText: 'SCAN',
  barcodeScanner: {
    title: 'Barcode scanner',
    text1: 'Where can I find the scannable code?',
    text2: 'The scannable code is usually printed on the side of the package and is identifiable by the letters "PZN".',
    text3: 'Which codes can be scanned?',
    text4: 'We specialize in pharmacy-related products. Other products may not be recognized.',
    text5: 'What to do if the code is not recognized?',
    text6: 'If the code is not recognized immediately, move or tilt the camera slightly over the code. You can also adjust the distance. Make sure to have good lighting!',
    text7: 'Report a problem',
    text8: 'Scan barcode',
    messages: {
      errorReadingBarcode: 'Please try again. The barcode could not be read. Other problems with scanning?',
      productNotFound: 'The product could not be found in our PZN database. Other problems with scanning?',
      fileSizeLimit: 'Your file could not be scanned. Your file exceeds the size limit of {uploadLimit} MB. Other problems with scanning?',
      fileTypeNotSupported: 'The selected file format {type} is unfortunately invalid. Please choose one of the following formats to upload your barcode: .jpg, .jpeg, .png. Other problems with scanning?',
      cameraNotSupported: 'Oops, it looks like we cannot access your camera. Please enable it in your browser settings or check if it is properly connected.',
    },
  },
}

export default productSearchBar
